module.exports = __webpack_public_path__ + "static/img/A66.8c4ba4fe.jpg";